module.exports = __webpack_public_path__ + "img/pic_default_secret.40168f32.png";